import * as actionTypes from "../Actions/UserActionTypes";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "REDUCER:USER";

const initialState = {
    customUserData: null //application custom data for logged in user
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.USER_CLEAR_DATA:
            LogService.info(LOG_TAG, "reduce", "" + action.type);
            return {
                ...initialState,
            };

        case actionTypes.USER_CUSTOM_DATA_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type);
            return {
                ...state,
                customUserData: action.payload.customData,
            };

        default:
            return state;
    }
}
